import { makeStateKey } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { CacheRef, resolverSSGFirst } from './ssg-first.utils';
import type { PaginaEntry } from '@core/interfaces/modyo';

const STATE_KEY = makeStateKey<PaginaEntry>('pagina-datos-economicos-seccion-2');
const cache: CacheRef<PaginaEntry> = { valor: null };

export const resetCacheClienteDatosEconomicosSeccion2 = (): void => {
  cache.valor = null;
};

export const datosEconomicosSeccion2Resolver: ResolveFn<PaginaEntry | null> = (): Observable<PaginaEntry | null> =>
  resolverSSGFirst({
    stateKey: STATE_KEY,
    cache,
    rutaSsg: 'datos-economicos-seccion-2',
    uidTipo: 'pagina',
    slug: 'paginadatoseconomicosseccion2',
  });
